/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

// Local Deps
// import { Button } from 'antd';
import './InventoryManagement.scss';
import InventoryManagementGrid from '../../components/grids/InventoryManagementGrid';
import AddInventory from '../../components/AddInventory';
import UploadInventory from '../../components/UploadInventory/UploadInventory';
import InventoryManagementMenu from '../../components/InventoryManagementMenu';
// import uploadInventoryHelp from '../../HelpFiles/Inventory Management Upload Example and Instructions.pdf'
import Loading from '../../components/Loading';
// import HelpDocButton from '../../components/primitives/HelpDocButton';
import { s3SupportDocs } from '../../config/properties';
import Subscription from '../../components/Subscription/Subscription';

const uploadInventoryHelp = `${s3SupportDocs}/ToolingAndInventory/Inventory Management Upload Example and Instructions.pdf`


class InventoryManagement extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isDownloading: PropTypes.bool.isRequired,
    auth: PropTypes.object.isRequired,
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func.isRequired,
    orgName: PropTypes.string.isRequired,
    // userOrgId: PropTypes.string.isRequired,
    // changeMetaDataBack: PropTypes.func.isRequired,
    onInventoryFilter: PropTypes.func.isRequired,
    inventoryFilter: PropTypes.object.isRequired,
    onReturnToMainPage: PropTypes.func.isRequired,

  };

  static defaultProps = {
    selectedMenu: {
      text: 'Inventory Management',
      value: 'inventoryGrid',
    },
  };

  render() {
    const {
      isLoading,
      isDownloading,
      auth,
      selectedMenu,
      onMenuClick,
      orgName,
      // userOrgId,
      // changeMetaDataBack,
      onInventoryFilter,
      inventoryFilter,
      onReturnToMainPage,


    } = this.props;
    const preposition = selectedMenu.text.includes('Inventory Management') ? 'for' : 'for';
    return (
      <Subscription service="Inventory Management" level="Advanced">
        <div className="nf-account-admin">
          <Helmet>
            <meta charSet="utf-8" />
            <title>NFFS ICON - Inventory Management Page</title>
            <meta name="description" content="description1" />
            <meta name="keywords" content="keyword1,keyword2,keyword3" />
          </Helmet>

          <Row className="nf-account-admin__header">
            {/* <!-- HEADER --> */}
            <Col xs={1} />
            <Col>
              {!orgName && (
                <h1>
                  {selectedMenu.text}
                  {selectedMenu.value === 'uploadInventory' && (
                    <a href={uploadInventoryHelp} target="_blank">
                      <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                        PDF Help File
                      </Button>
                    </a>
                  )}
                </h1>
              )}
              {orgName && (
                <h1>
                  {`${selectedMenu.text} ${preposition} ${orgName}`}
                  {selectedMenu.value === 'uploadInventory' && (
                    <a href={uploadInventoryHelp} target="_blank">
                      <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                        PDF Help File
                      </Button>
                    </a>
                  )}
                </h1>
              )}
            </Col>
            {/* {userOrgId !== auth.organizationId &&
              isLoading === false && (
                <Col className="button-wrapper">
                  <div>
                    <Button
                      onClick={() => {
                        changeMetaDataBack(userOrgId);
                      }}
                    >
                      go back to your organization?
                    </Button>
                  </div>
                </Col>
              )} */}
          </Row>
          <Row
            style={{
              flexWrap: 'nowrap',
            }}
          >
            <Col xs={2} className="nf-account-admin__side-panel">
              <InventoryManagementMenu
                onMenuClick={onMenuClick}
                selectedMenu={selectedMenu}
                onInventoryFilter={onInventoryFilter}
                isDownloading={isDownloading}
              />
            </Col>
            <Col
              style={{
                padding: 0,
              }}
            >
              {/* <!-- LOADING --> */}
              {isLoading && <Loading text='Loading Inventory Management...' />}

              {/* <!-- CONTENT --> */}
              {!isLoading && (
                <div className="nf-account-admin__content">
                  <Row className="nf-row--justify-end" />{' '}
                  {/* <!-- Admin Caps Grid --> */}
                  <div className="nf-account-admin__grid">
                    {selectedMenu.value === 'addInventory' && (
                      <AddInventory
                        auth={auth}
                        onReturnToMainPage={onReturnToMainPage}
                      />
                    )}

                    {selectedMenu.value === 'inventoryGrid' && (
                      <InventoryManagementGrid
                        auth={auth}
                        inventoryFilter={inventoryFilter}
                      />
                    )}

                    {selectedMenu.value === 'uploadInventory' && (
                      <UploadInventory
                        auth={auth}
                        onReturnToMainPage={onReturnToMainPage}
                      />
                    )}

                    {
                      selectedMenu.value !== 'addInventory' &&
                      selectedMenu.value !== 'uploadInventory' &&
                      selectedMenu.value !== 'downloadInventory' &&
                      selectedMenu.value !== 'inventoryGrid' &&
                      <div>TBD</div>}
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div >
      </Subscription>
    );
  }
}

export default InventoryManagement;



// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/InventoryManagement.jsx